export default {
  position: {
    type: 'string',
    required: true,
  },
  competencyLevel: {
    type: 'string',
  },
  officeId: {
    type: 'string',
  },

  compensationType: {
    type: 'string',
    required: true,
  },
  compensationSum: {
    type: 'string',
    required: true,
  },
  currency: {
    type: 'string',
    required: true,
  },
};
